import ListItem from "@mui/material/ListItem";
import { useState } from "react";
import { ZONE_SPEC_OPTIONS } from "@/features/cards/zone-v2/core/zone-spec-options";
import { DataViewer } from "@/features/data-viewer/data-viewer";
import { type PanelLayout, useZoneDataViewerSpec } from "@/features/data-viewer/spec/use-data-viewer-spec";
import { DEFAULT_PICKER_FILTER, type PickerFilter } from "@/features/data-viewer/stream-picker/picker-filter";
import { StreamPicker } from "@/features/data-viewer/stream-picker/stream-picker";
import { CLOCK_CADENCE } from "@/providers/wall-clock";

/** Its own component so the streams request only runs when the flag lets the viewer render. */
export function ZoneDataViewerSection({ zoneId }: { zoneId: string }) {
    const [panelLayout, setPanelLayout] = useState<PanelLayout>("stacked");
    const [addedIds, setAddedIds] = useState<number[]>([]);
    const [pickerFilter, setPickerFilter] = useState<PickerFilter>(DEFAULT_PICKER_FILTER);

    const {
        spec: zoneSpec,
        isLoading,
        isError,
        isEmpty,
        plottedStreams,
        isPlottable,
    } = useZoneDataViewerSpec(zoneId, panelLayout, ZONE_SPEC_OPTIONS, addedIds);

    return (
        <ListItem className={"FullsizeZoneOverviewListItem--InfoCard"}>
            <div className={"w-full flex flex-col"}>
                <DataViewer
                    controls={
                        <StreamPicker
                            addedIds={addedIds}
                            isPlottable={isPlottable}
                            onAdd={(id) => setAddedIds((ids) => [...ids, id])}
                            onRemove={(id) => setAddedIds((ids) => ids.filter((other) => other !== id))}
                            filter={pickerFilter}
                            onFilterChange={setPickerFilter}
                            plottedStreams={plottedStreams}
                            zoneId={zoneId}
                        />
                    }
                    panelLayout={{ layout: panelLayout, onChange: setPanelLayout }}
                    showCsvDownload
                    initialSpec={zoneSpec}
                    isLoading={isLoading}
                    isError={isError}
                    isEmpty={isEmpty}
                    autoRefreshCadence={CLOCK_CADENCE.MINUTES_5}
                    resizable={false}
                />
            </div>
        </ListItem>
    );
}
